<div *ngIf="phases != null" class="container">
    <div class="block-title">
        <div class="title"> {{ 'SHARED.EXTERNAL.CMR.ACTIONS.DOCUMENTATIONSIGNING.CAPTION' | translate }} </div>
    </div>
    <ng-container *ngIf="currentPhase != null">
  
        <shared-sign [uuid]="currentPhase.uuid" [agent]="signatureAgent" (signedChanged)="onPhaseSigned()">
        </shared-sign>

    </ng-container>
</div>